var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixEventsV1Ticket from '@wix/ambassador-events-v1-ticket/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var OrderStatus;
(function (OrderStatus) {
    /** Order status not available for this request fieldset */
    OrderStatus["NA_ORDER_STATUS"] = "NA_ORDER_STATUS";
    /** Order is confirmed, no payment required */
    OrderStatus["FREE"] = "FREE";
    /** Order was paid but payment gateway suspended the payment. Eventually changes to PAID */
    OrderStatus["PENDING"] = "PENDING";
    /** Order paid via payment gateway */
    OrderStatus["PAID"] = "PAID";
    /** Order confirmed but has to be paid via offline payment and status manually updated to PAID */
    OrderStatus["OFFLINE_PENDING"] = "OFFLINE_PENDING";
    /** Order is awaiting for payment in Cashier */
    OrderStatus["INITIATED"] = "INITIATED";
    /** Order was canceled */
    OrderStatus["CANCELED"] = "CANCELED";
    /** Order payment was declined */
    OrderStatus["DECLINED"] = "DECLINED";
})(OrderStatus || (OrderStatus = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var ChannelType;
(function (ChannelType) {
    /** Buyer created order via one of the online channels (website, mobile app, etc.) */
    ChannelType["ONLINE"] = "ONLINE";
    /** Order created and money collected by the sales person */
    ChannelType["OFFLINE_POS"] = "OFFLINE_POS";
})(ChannelType || (ChannelType = {}));
export var TicketFieldset;
(function (TicketFieldset) {
    /** Include guest details in ticket response */
    TicketFieldset["GUEST_DETAILS"] = "GUEST_DETAILS";
    /** Include ticket details in ticket response */
    TicketFieldset["TICKET_DETAILS"] = "TICKET_DETAILS";
    /** Include individual guest form in ticket response */
    TicketFieldset["GUEST_FORM"] = "GUEST_FORM";
})(TicketFieldset || (TicketFieldset = {}));
export var State;
(function (State) {
    /** Returns only archived orders' tickets */
    State["ORDER_ARCHIVED"] = "ORDER_ARCHIVED";
    /** Returns only non-archived orders' tickets */
    State["ORDER_ACTIVE"] = "ORDER_ACTIVE";
    /** Returns only archived tickets */
    State["TICKET_ARCHIVED"] = "TICKET_ARCHIVED";
    /** Returns only non-archived tickets */
    State["TICKET_ACTIVE"] = "TICKET_ACTIVE";
    /** Returns only checked-in tickets */
    State["CHECKED_IN"] = "CHECKED_IN";
    /** Returns only non-checked-in tickets */
    State["NON_CHECKED_IN"] = "NON_CHECKED_IN";
    /** Returns only free tickets */
    State["FREE"] = "FREE";
    /** Returns only paid tickets */
    State["PAID"] = "PAID";
    /** Returns only member tickets */
    State["MEMBER"] = "MEMBER";
})(State || (State = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _bulkUpdateTicketsRequest = {};
const _bulkUpdateTicketsResponse = { tickets: '_ticketingTicket' };
const _checkInTicketRequest = {};
const _checkInTicketResponse = { tickets: '_ticketingTicket' };
const _deleteTicketCheckInRequest = {};
const _deleteTicketCheckInResponse = { tickets: '_ticketingTicket' };
const _formattedAddress = { address: 'wix.common.Address' };
const _formResponse = { inputValues: '_inputValue' };
const _getTicketRequest = {};
const _getTicketResponse = { ticket: '_ticketingTicket' };
const _guestDetails = { form: '_formResponse' };
const _guestDetailsUpdate = { form: '_formResponse' };
const _inputValue = { address: '_formattedAddress' };
const _listTicketsRequest = {};
const _listTicketsResponse = { tickets: '_ticketingTicket' };
const _ticketingTicket = { guestDetails: '_guestDetails' };
const _updateTicketRequest = {
    checkoutForm: '_formResponse',
    guestDetails: '_guestDetailsUpdate',
};
const _updateTicketResponse = { ticket: '_ticketingTicket' };
/**
 * Retrieves a list of up to 100 tickets.
 *
 * <!--
 * >**Note:** This function is restricted and only runs if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 * @param eventId - Event IDs.
 * @public
 * @requiredField eventId
 * @param options - Options for defining the returned list of tickets.
 * @adminMethod
 */
export function listTickets(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            offset: '$[1].offset',
            limit: '$[1].limit',
            order: '$[1].order',
            orderNumber: '$[1].orderNumber',
            ticketNumber: '$[1].ticketNumber',
            searchPhrase: '$[1].searchPhrase',
            orderStatus: '$[1].orderStatus',
            orderArchived: '$[1].orderArchived',
            checkedIn: '$[1].checkedIn',
            fieldset: '$[1].fieldset',
            state: '$[1].state',
            memberId: '$[1].memberId',
            facet: '$[1].facet',
            sort: '$[1].sort',
            contactId: '$[1].contactId',
            ticketDefinitionId: '$[1].ticketDefinitionId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listTicketsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listTicketsResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['Array#tickets']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Ticket.listTickets(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a ticket by the unique ticket number.
 * @public
 * @requiredField identifiers
 * @requiredField identifiers.eventId
 * @requiredField identifiers.ticketNumber
 * @param identifiers - Details for the ticket to retrieve.
 * @param options - Options for the returned ticket data.
 * @adminMethod
 * @returns Ticket.
 */
export function getTicket(identifiers, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0].eventId',
            ticketNumber: '$[0].ticketNumber',
            fieldset: '$[1].fieldset',
        };
        const responseTransformation = '$.ticket';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getTicketRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getTicketResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['ticket']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers, options]);
        const reqOpts = ambassadorWixEventsV1Ticket.getTicket(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Checks in 1 or more tickets.
 * @public
 * @requiredField eventId
 * @param eventId - Event ID to which the ticket belongs.
 * @param options - Options for tickets to check-in.
 * @adminMethod
 */
export function checkInTickets(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            orderNumber: '$[1].orderNumber',
            ticketNumber: '$[1].ticketNumber',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _checkInTicketRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _checkInTicketResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['Array#tickets']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Ticket.checkInTicket(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes check-ins for 1 or more tickets.
 * @public
 * @requiredField eventId
 * @param eventId - Event ID to which the ticket belongs.
 * @param options - Options for tickets to delete.
 * @adminMethod
 */
export function deleteTicketCheckIns(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            orderNumber: '$[1].orderNumber',
            ticketNumber: '$[1].ticketNumber',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteTicketCheckInRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteTicketCheckInResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['Array#tickets']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Ticket.deleteTicketCheckIn(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a ticket.
 * @public
 * @requiredField identifiers
 * @requiredField identifiers.eventId
 * @requiredField identifiers.ticketNumber
 * @param identifiers - Details for the ticket to update.
 * @param options - Ticket details to update.
 * @adminMethod
 */
export function updateTicket(identifiers, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0].eventId',
            ticketNumber: '$[0].ticketNumber',
            fields: '$[1].fields',
            checkoutForm: '$[1].checkoutForm',
            archived: '$[1].archived',
            guestDetails: '$[1].guestDetails',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateTicketRequest,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetailsUpdate,
                _inputValue,
            },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateTicketResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['ticket']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers, options]);
        const reqOpts = ambassadorWixEventsV1Ticket.updateTicket(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Archives multiple tickets.
 * @public
 * @requiredField eventId
 * @param options - Options for updating the tickets.
 * @param eventId - Event ID to which the ticket belongs.
 * @adminMethod
 */
export function bulkUpdateTickets(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            ticketNumber: '$[1].ticketNumber',
            archived: '$[1].archived',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkUpdateTicketsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkUpdateTicketsResponse,
            depSchemas: {
                _formResponse,
                _formattedAddress,
                _guestDetails,
                _inputValue,
                _ticketingTicket,
            },
            fqdnTransformation: {
                paths: [...['Array#tickets']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Ticket.bulkUpdateTickets(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=events-v1-ticket.universal.js.map